import React, { useEffect, useRef, useState } from 'react';
import { Script } from 'gatsby';
import './HubspotForm.scss';

function HubspotForm({ formId = 'd930297b-da66-4fc4-a23f-b97b71dc9a06' }) {
  const containerRef = useRef(null);
  const [scriptLoaded, setScriptLoaded] = useState(false);

  const randomId = formId.split('-')[0];
  const formattedFormId = `hubspotForm-${randomId}`;

  useEffect(() => {
    if (!scriptLoaded) return;
    if (typeof window === 'undefined' || !window.hbspt || !containerRef.current)
      return;

    // Clear container before inserting form again
    containerRef.current.innerHTML = '';

    window.hbspt.forms.create({
      portalId: '5418301',
      formId,
      target: `#${formattedFormId}`,
      onFormSubmitted: (form, data) => {
        const pancake = document.querySelector('.HubspotFormPancakeCard');
        if (pancake) pancake.scrollIntoView({ behavior: 'smooth' });

        if (formId == 'c94bf151-c61e-4380-983d-4ad43c064802') {
          const gated = document.querySelector('.CalculatorGated');
          if (gated) gated.classList.remove('CalculatorGated');
        }

        if (formId == 'e0bcc9fa-44f2-4d25-a0ba-99273f0207b9') {
          const formData = data.submissionValues;
          fetch('/.netlify/functions/free-trial', {
            method: 'POST',
            body: JSON.stringify({
              formData,
            }),
          });
        }
      },
      onBeforeFormSubmit: (props) => {
        if (formId == 'c94bf151-c61e-4380-983d-4ad43c064802') {
          const numberOfSoftwareDevs = document.querySelector(
            '[data-roi-number-software-dev]'
          ).dataset.roiNumberSoftwareDev;
          const salaryOfSoftwareDevs = document.querySelector(
            '[data-roi-salary-software-dev]'
          ).dataset.roiSalarySoftwareDev;
          const numberOfPlatformDevs = document.querySelector(
            '[data-roi-number-platform-dev]'
          ).dataset.roiNumberPlatformDev;
          const salaryOfPlatformDevs = document.querySelector(
            '[data-roi-salary-platform-dev]'
          ).dataset.roiSalaryPlatformDev;
          const gainsResults =
            document.querySelector('[data-roi-savings]').dataset.roiSavings;
          document.querySelector("[name='roi_number_devs']").value =
            numberOfSoftwareDevs;
          document.querySelector("[name='roi_salary_devs']").value =
            salaryOfSoftwareDevs;
          document.querySelector("[name='roi_number_platform']").value =
            numberOfPlatformDevs;
          document.querySelector("[name='roi_salary_platform']").value =
            salaryOfPlatformDevs;
          document.querySelector("[name='roi_gains_results']").value =
            gainsResults;
        }
      },
    });
  }, [scriptLoaded, formId]);

  return (
    <>
      <Script
        src="https://js.hsforms.net/forms/v2.js"
        strategy="post-hydrate"
        onLoad={() => setScriptLoaded(true)}
      />
      <div
        className="HubspotForm"
        id={formattedFormId}
        ref={containerRef}
      ></div>
    </>
  );
}

export default HubspotForm;
